/*                                      */

/**
 *
 *
 */
export const VERSION = '5.27.0';
export const PUBLIC_VERSION = '5';
